import React from 'react';
import { Progress } from 'antd';

const _Progress = (props) => {
  const { percent } = props;

  return (
    <Progress {...props} percent={percent === null ? undefined : percent} />
  );
};

export default _Progress;
